export const notNull = (num) => {
    if (num === null || num === undefined) {
        return false
    } else {
        return true;
    }
}